import React, { useEffect, useState } from "react";
import { authService } from "../services";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import "../styles/Dashboard.css"

function Interest() {
  const [interestList, setInterestList] = useState([]);
  const [cuisinesList, setCuisinesList] = useState([]);
  const [selectedInterests, setSelectedInterests] = useState([]);
  const [selectedCuisines, setSelectedCuisines] = useState([]);

  const navigate = useNavigate();

  const location = useLocation();
  const formData = location.state || {};

  console.log("first", formData)

  useEffect(() => {
    getInterestList();
    getCuisinesList();
  }, []);

  // Fetch Interest List
  const getInterestList = async () => {
    try {
      const res = await authService.getInterestList();
      if (res && res.data) {
        setInterestList(res.data);
      }
    } catch (error) {
      console.log("Error fetching interest list");
    }
  };

  // Fetch Cuisines List
  const getCuisinesList = async () => {
    try {
      const res = await authService.getCuisinesList();
      if (res && res.data) {
        setCuisinesList(res.data);
      }
    } catch (error) {
      console.log("Error fetching cuisines list");
    }
  };

  // Handle checkbox change
  const handleCheckboxChange = (id, type) => {
    if (type === "interest") {
      setSelectedInterests((prev) =>
        prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
      );
    } else if (type === "cuisine") {
      setSelectedCuisines((prev) =>
        prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
      );
    }
  };

  // Handle Next button click
  const handleNext = () => {
    const updatedFormData = {
      ...formData,
      specialityPrefrences: selectedInterests.length > 0 ? selectedInterests : [0],
      cuisinePrefrences: selectedCuisines.length > 0 ? selectedCuisines : [0],
    };
    console.log("Updated Form Data Interest:", updatedFormData);
    navigate("/allLocation", { state: updatedFormData });
  };

  return (
    <div  className="landing-container mobile-css2">
      <div className="container">
      <div className="logo-container mobile-css">
           <img src="/images/mainLogo.png" alt="Logo" className="mian-logo"/>
      </div>
       
       <div className="check-box-design">
        <div className="text-center text-white">
          <h2>Help us personalise your experience</h2>
        </div>

        {/* First Checkbox - Interests */}
        <div className="check-box1">
          <h4 className="text-white">Special Interests</h4>
          <p className="text-white">Check all that apply</p>

          <div className="row mb-2 check-count1">
            {interestList.map((interest) => (
              <div key={interest.id} className="col-md-3 design-check" >
                <input
                  type="checkbox"
                  className="form-check-input"
                  checked={selectedInterests.includes(interest.id)}
                  onChange={() => handleCheckboxChange(interest.id, "interest")}
                />
                <label className="form-check-label text-white">{interest.specilityName}</label>
              </div>
            ))}
          </div>
        </div>

 {/* Second Checkbox - Cuisines */}
        <div className="check-box1 second2">
          <h4 className="text-white">Favourite Cuisines</h4>
          <p className="text-white">Check all that apply</p>

          <div className="row mb-2 check-count1">
            {cuisinesList.map((cuisine) => (
              <div key={cuisine.id} className="col-md-3 design-check" >
                <input
                  type="checkbox"
                  className="form-check-input"
                  checked={selectedCuisines.includes(cuisine.id)}
                  onChange={() => handleCheckboxChange(cuisine.id, "cuisine")}
                />
                <label className="form-check-label text-white">{cuisine.cusineName}</label>
              </div>
            ))}
          </div>
        </div>

        {/* Button */}
        <div className="text-center">
          <button
            className="sign-up-button check-box"
           
            onClick={handleNext}
          >
            Next
          </button>
        </div>
        </div>

      </div>
    </div>
  );
}

export default Interest;


